/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfcraft_TypeInputs */

const en_pc_alt_t_pdfcraft_type = /** @type {(inputs: Pc_Alt_T_Pdfcraft_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native PDF workbench (alpha)`)
};

const zh_pc_alt_t_pdfcraft_type = /** @type {(inputs: Pc_Alt_T_Pdfcraft_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生 PDF 工作台（alpha）`)
};

/**
* | output |
* | --- |
* | "Native PDF workbench (alpha)" |
*
* @param {Pc_Alt_T_Pdfcraft_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfcraft_type = /** @type {((inputs?: Pc_Alt_T_Pdfcraft_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfcraft_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfcraft_type(inputs)
	return zh_pc_alt_t_pdfcraft_type(inputs)
});
export { pc_alt_t_pdfcraft_type as "pc.alt.t.pdfcraft.type" }